import React from "react";
import { Modal, ScrollArea } from '@mantine/core';

const ModalWrapperWithoutFooter = ({
    children,
    stateShow,
    fnHide,
    stateHideOnClickOutSide = true,
    stateTitle = '',
    stateSize = 'md',
    stateScrollArea = true,

    stateOverlayZIndex = null,
    stateContentSX = {},
    stateWithCloseButton = true,
}) => {
    const sxZIndex = stateOverlayZIndex === null ? {} : { zIndex: stateOverlayZIndex }

    return (
        <Modal.Root
            opened={stateShow}
            onClose={fnHide}
            closeOnClickOutside={stateHideOnClickOutSide}
            size={stateSize}
            centered

            styles={() => ({
                overlay: {
                    ...sxZIndex
                },
                content: { stateContentSX }
            })}
        >
            <Modal.Overlay />

            <Modal.Content
                scrollAreaComponent={stateScrollArea ? ScrollArea.Autosize : null}
            >
                <Modal.Header>
                    <Modal.Title sx={{ fontWeight: '500' }}>{stateTitle}</Modal.Title>
                    {stateWithCloseButton && <Modal.CloseButton />}
                </Modal.Header>

                <Modal.Body>
                    {children}
                </Modal.Body>
            </Modal.Content>
        </Modal.Root>
    )
}

export default ModalWrapperWithoutFooter;